import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { PropertyProviderModel } from '../models/property-provider.model';
import { PropertyProviderDisplaySetModel } from '../models/property-provider-display-set.model';

@Injectable({
  providedIn: 'root'
})
export class PropertyProvidersService {

  constructor(private http: HttpClient, private config: ConfigService) { }

  public GetPropertyProviders(): Observable<Array<PropertyProviderModel>> {
    return this.http.get<Array<PropertyProviderModel>>(this.config.getApiRoute('api/v3/client-portal/property-providers')).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }

  public GetProvidersDisplaySet(): Observable<Array<PropertyProviderDisplaySetModel>> {
    return this.http.get<Array<PropertyProviderDisplaySetModel>>(this.config.getApiRoute('api/v3/client-portal/property-providers/display-set')).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }

  public GetProvider(id: string): Observable<PropertyProviderModel> {
    return this.http.get<PropertyProviderModel>(this.config.getApiRoute('api/v3/client-portal/property-providers/' + id)).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }

  public SaveProvider(model: PropertyProviderModel): Observable<PropertyProviderModel> {
    return this.http.put<PropertyProviderModel>(this.config.getApiRoute('api/v3/client-portal/property-providers/' + model.id), model).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }
}